import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ClockSection from "./components/ClockSection";
import GameSection from "./components/GameSection";
import ScoreSection from "./components/ScoreSection";
import SettingsSection from "./components/SettingsSection";

export default function Home() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <HeroSection />
        <ClockSection />
        <GameSection />
        <ScoreSection />
        <SettingsSection />
      </main>
      <Footer />
    </div>
  );
}